<template>
  <div style="position: relative">
    <el-tree
      :data="data"
      :props="props"
      :node-key="nodeKey"
      :expand-on-click-node="false"
      default-expand-all
      highlight-current
      @node-click="nodeClick"
    >
      <span slot-scope="{ node, data }" class="custom-tree-node">
        <span>{{ node.label }}</span>
        <el-dropdown v-if="canEdit(data)">
          <span>
            <i style="color: blue" class="el-icon-edit" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-if="canAdd(data)"
              @click.native="modifyNode(null, data)"
            >添加</el-dropdown-item>
            <el-dropdown-item
              v-if="canModify(data)"
              @click.native="modifyNode(data)"
            >修改</el-dropdown-item>
            <el-dropdown-item
              v-if="canDel(data, node)"
              @click.native="removeNode(data, node)"
            >删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </el-tree>
  </div>
</template>

<script>
import store from '@store/index.js'

export default {
  props: {
    nodeKey: String,
    props: Object,
    url: String,
    editable: {
      type: Boolean,
      default: true
    },
    dealReturnData: Function,
    addState: {
      type: Boolean,
      default: true
    },
    editState: {
      type: Boolean,
      default: true
    },
    delState: {
      type: Boolean,
      default: true
    },
    isDispaly: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      data: [],
      showEditTool: false
    }
  },
  computed: {
    userInfo: function() {
      return store.state.userInfo
    },
    userOrgId: function() {
      return this.userInfo.org.fOrganizationID
    }
  },
  mounted: function() {
    this.refresh()
  },
  methods: {
    canEdit: function(data) {
      // return this.editable && (data.editable == undefined || data.editable > 0)
      return this.isDispaly
    },
    //  添加
    canAdd: function(data) {
      // return this.addState
      // return data.editable == undefined || (data.editable & 0x01) == 0x01 || this.addState
      return this.addState
    },
    // 修改
    canModify: function(data) {
      // console.log(data, "canModify,data");
      if (data.fDeptID == 0) {
        return false
      } else {
        // return data.editable == undefined || (data.editable & 0x02) == 0x02 || this.editState
        return this.editState
      }
    },
    // 删除
    canDel: function(data, node) {
      // console.log(data, "data");
      // console.log(node, "node");
      // return (
      //   (data.editable == undefined || (data.editable & 0x04) == 0x04) &&
      //   node.childNodes.length == 0 &&
      //   this.delState
      // );
      return this.delState
    },

    modifyNode(data, parent) {
      this.$emit('node-modify', data, parent)
    },

    removeNode(data, node) {
      this.$confirm(`是否删除【${node.label}】?`, '提示', { type: 'warning' })
        .then(() => {
          this.$emit('node-delete', data)
        })
        .catch(() => {
          // 用户取消操作
        })
    },

    nodeClick: function(data, node, inst) {
      this.$emit('node-click', data, node, inst)
    },

    refresh: function() {
      this.$httpPost(this.url, {}).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }

        if (this.dealReturnData) {
          this.data = [this.dealReturnData(res.datalist)]
        } else {
          this.data = [res.datalist]
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding-right: 8px;

  & > .el-dropdown {
    display: none;
  }

  &:hover {
    & > .el-dropdown {
      display: inline;
      margin-left: 5px;
    }
  }
}
</style>
